module.exports = __webpack_public_path__ + "img/titlePc26-safeimagekit.b5ace380.png";